import React from 'react';
import moment from 'moment';
import { Field, Checkbox, Spinner } from '../../components/Common';
import { validateEmail, validatePassword } from '../../utils/validForm';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/fr';
import 'rc-datepicker/lib/style.css';
import { Link } from "react-router-dom";

export default class SignOnForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nom: '',
            prenom: '',
            dateNaissance: '',
            numeroContrat: '',
            email: '',
            motDePasse: '',
            cgu: '0',
            displayPassword: false,
            displayConfirmPassword: false,
            error: {
                nom: '',
                prenom: '',
                dateNaissance: '',
                numeroContrat: '',
                email: '',
                motDePasse: '',
                confirmPassword: '',
                cgu: '',
            }
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(value) {
        this.setState({ dateNaissance: value })
    }

    dateOnChange = (jsDate, dateString) => {
        let obj = {}
        obj.dateNaissance = (dateString === 'Invalid date') ? 'is-invalid' : ''
        this.setState(prevState => ({
            dateNaissance: dateString,
            error: {
                ...prevState.error,
                ...obj
            }
        }));
    }

    toggleDisplayPassword = (key) => {
        this.setState(prevState => ({ [key]: !prevState[key] }));
    }

    handleOnChange(key, e) {
        let value = e.target.value;
        if (e.target.type === "checkbox")
            value = e.target.checked ? "1" : "0";
        this.validPassword(key, value);
        this.validForm(key, value);
        this.setState(() => ({ [key]: value }));
    }

    validForm = (key, value) => {
        let obj = {}
        if (key === "email") {
            obj.email = !validateEmail(value) && ' is-invalid';
            this.setState(prevState => ({
                error: {
                    ...prevState.error,
                    ...obj
                }
            }));
        }
        if (key === "motDePasse") {
            obj.confirmPassword = value != this.state.confirmPassword ? ' is-invalid' : '';
            this.setState(prevState => ({
                error: {
                    ...prevState.error,
                    ...obj
                }
            }));
        }
        if (key === "confirmPassword") {
            obj.confirmPassword = value != this.state.motDePasse ? ' is-invalid' : '';
            this.setState(prevState => ({
                error: {
                    ...prevState.error,
                    ...obj
                }
            }));
        }
    }

    validPassword = (key, value) => {
        let obj = {}
        if (key === "motDePasse")
            obj.motDePasse = !validatePassword(value) && ' is-invalid';
        if (key === "confirmPassword")
            obj.confirmPassword = !validatePassword(value) && ' is-invalid';
        this.setState(prevState => ({
            error: {
                ...prevState.error,
                ...obj
            }
        }));
    }


    isDisableButton = () => (
        !this.state.prenom
        || !this.state.nom
        || !this.state.dateNaissance
        || !this.state.motDePasse
        || !this.state.email
        || !this.state.numeroContrat
        || this.state.error.confirmPassword
        || this.state.error.motDePasse
        || this.state.cgu === '0'
        || !validateEmail(this.state.email)
        || this.state.error.dateNaissance
    )

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit({
            nom: this.state.nom,
            prenom: this.state.prenom,
            numeroContrat: this.state.numeroContrat,
            email: this.state.email,
            motDePasse: this.state.motDePasse,
            dateNaissance: moment(this.state.dateNaissance).format(), // moment(this.state.dateNaissance).format('YYYY-MM-DDT00:mm:ss'),
            hostWebsite: window.location.origin
        })
    }

    render() {
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <Field
                        label="Nom *"
                        type="text"
                        // placeholder="DUPOND"
                        _className={"form-control  " + this.state.error.nom}
                        value={this.state.nom}
                        onChange={this.handleOnChange.bind(this, "nom")}
                        error={this.state.error.nom}

                    />
                    <Field
                        label="Prénom *"
                        type="text"
                        // placeholder="ALAIN"
                        _className={"form-control  " + this.state.error.prenom}
                        value={this.state.prenom}
                        onChange={this.handleOnChange.bind(this, "prenom")}
                        error={this.state.error.prenom}

                    />
                    <div className="form-group">
                        <label>Date de naissance *</label>
                        <DatePickerInput
                            onChange={this.dateOnChange}
                            value={this.state.dateNaissance}
                            maxDate={moment()}
                            className={'custom-datepicker ' + this.state.error.dateNaissance}
                            showOnInputClick={true}
                            iconClassName='cal-icon'
                            locale = 'fr'
                        />
                        {this.state.error.dateNaissance &&
                            <div className="invalid-feedback invalid-date">
                                Veuillez entrer votre date de naissance.
                                </div>
                        }
                    </div>
                    <div className="form-group">
	                    <div className="tooltip-toggle btn-info-tooltip" 
	                        aria-label="Votre numéro de contrat se trouve sur votre avis d'échéance et votre contrat initial. Merci de respecter le format tel qu'il est indiqué sur le document." 
	                         tabIndex="0"
	                       >
	                   </div>
	                    <Field
	                        label="Numéro de contrat *"
	                        type="text"
	                        _className={"form-control  address" + this.props.error.numeroContrat}
	                        value={this.state.numeroContrat}
	                        onChange={this.handleOnChange.bind(this, "numeroContrat")}
	                    // placeholder="1234567890AERF12"
	                    />
                    </div>
                    <Field
                        label="Email *"
                        type="email"
                        _className={"form-control  " + this.state.error.email}
                        value={this.state.email}
                        onChange={this.handleOnChange.bind(this, "email")}
                        error={this.state.error.email}
                        // placeholder="adupond@hotmail.com"
                        errorMessage="Adresse email non valide "
                    />
                    <div className="form-group">
                        <div className="tooltip-toggle btn-info-tooltip" 
                        	aria-label="Votre mot de passe doit être composé d'au moins 12 caractères avec au moins une lettre majuscule, une lettre minuscule, un chiffre, aucun caractère accentué et un caractère spécial parmi les suivants : ! @ # $ % ^ & *" 
                              tabIndex="0"
                            >
                        </div>
                        <Field
                            label="Mot de passe *"
                            type={this.state.displayPassword ? 'text' : 'password'}
                            _className={"form-control  " + this.state.error.motDePasse}
                            value={this.state.motDePasse}
                            onChange={this.handleOnChange.bind(this, "motDePasse")}
                            error={this.state.error.motDePasse}
                            errorMessage=" "
                        //placeholder="*************"
                        />
                        <div className={this.state.displayPassword ? 'icon hidePwd' : 'icon showPwd'} onClick={() => this.toggleDisplayPassword('displayPassword')} ></div>
                    </div>
                    <div className="form-group">
                        <Field
                            type={this.state.displayConfirmPassword ? 'text' : 'password'}
                            label="Confirmation du mot de passe *"
                            _className={"form-control  " + this.state.error.confirmPassword}
                            error={this.state.error.confirmPassword}
                            autoFocus
                            value={this.state.confirmPassword}
                            onChange={this.handleOnChange.bind(this, 'confirmPassword')}
                            errorMessage=" "
                        />
                        <div className={this.state.displayConfirmPassword ? 'icon hidePwd' : 'icon showPwd'} onClick={() => this.toggleDisplayPassword('displayConfirmPassword')} ></div>
                    </div>
                    <div className="required-txt"> * Champs obligatoires</div>
                    <Checkbox
                        type="checkbox"
                        _id="cgu"
                        label={<div>J’ai lu et j’accepte les <Link to={`public-cgu/${this.props.cguId}`} target="_blank">conditions générales d’utilisation</Link> et la <Link to={`public-cgu/${this.props.cdcId}`} target="_blank">charte de confidentialité</Link></div>}
                        onChange={this.handleOnChange.bind(this, "cgu")}
                    />
                    <div className="button-container">
                        <button type="submit" className={`btn btn-primary btn-lg spinner-${this.props.spinner}`} disabled={this.isDisableButton()} >
                            <span>M'inscrire</span>
                            <Spinner status={this.props.spinner} />
                        </button>
                    </div>

                </form>
            </div >
        )
    }

}





// WEBPACK FOOTER //
// ./src/components/SignOnPage/SignOnForm.js